import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";

export default function OptionalContactStep({
  formData,
  setFormData,
  isWebsiteValid
}) {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <>
      <h2>{t("Start.optionalContactInfo")}</h2>

      <input
        ref={inputRef}
        type="text"
        placeholder={t("Start.phoneNumber")}
        value={formData.phoneNumber}
        onChange={e =>
          setFormData({ ...formData, phoneNumber: e.target.value })
        }
      />

      <input
        type="text"
        placeholder={t("Start.schoolWebsite")}
        value={formData.website}
        onChange={e =>
          setFormData({ ...formData, website: e.target.value })
        }
      />

      {formData.website && !isWebsiteValid && (
        <p className="input-error">
          {t("Start.errors.invalidWebsite")}
        </p>
      )}



      <textarea
        placeholder={t("Start.writeComments")}
        value={formData.notes}
        onChange={e =>
          setFormData({ ...formData, notes: e.target.value })
        }
      />
    </>
  );
}
